import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase-config";
import { useNavigate } from "react-router-dom";
import "../styles/form.css";
import "../styles/login.css";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  // Handle Email and Password Sign-In
  const handleEmailSignIn = async (e) => {
    e.preventDefault();
    setIsLoading(true); // Start loading

    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/"); // Redirect to Home or any other page after successful login
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  // Redirect to the Sign-Up Page
  const redirectToSignUp = () => {
    navigate("/signup");
  };

  return (
    <div className="login-container">
      <h2>Login</h2>
      {isLoading ? (
        <div className="loading-spinner">
          <p>Logging in, please wait...</p>
          {/* You can replace this with a spinner icon */}
        </div>
      ) : (
        <form onSubmit={handleEmailSignIn}>
          <div>
            <label>Email:</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <label>Password:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit">Login with Email</button>
        </form>
      )}

      <p>Don't have an account?</p>
      <button onClick={redirectToSignUp} className="signup-button">
        Sign Up
      </button>

      {error && <p className="error">{error}</p>}
    </div>
  );
};

export default Login;
